import { render, staticRenderFns } from "./LogReportTable.vue?vue&type=template&id=6bbd910c&"
import script from "./LogReportTable.vue?vue&type=script&lang=js&"
export * from "./LogReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports